import { Plugin } from 'prosemirror-state';

import { EditorOptions } from '@lyearn/lygo-core';

import TabsNodeView from './NodeView';

function plugins({ createReactNodeView, t }: EditorOptions) {
  return [
    new Plugin({
      props: {
        nodeViews: {
          tab_panel(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              component: TabsNodeView,
            });
          },
        },
      },
    }),
  ];
}

export default plugins;
